'use client'

import Logger from '@/helpers/logger'
import { ConfigApiResponseData, EnvironmentVariables } from '@/actions/config'
import { wrapNodeRequest } from '@lib-helpers'
import { createContext, ReactNode, useEffect, useMemo, useState } from 'react'

interface ConfigProviderProps {
    children: ReactNode
}

export interface ConfigProviderValue {
    envVariables: EnvironmentVariables | null
}

export const ConfigContext = createContext<ConfigProviderValue>({
    envVariables: null,
})

export const ConfigProvider = ({ children }: ConfigProviderProps) => {
    const [envVariables, setEnvVariables] = useState<EnvironmentVariables | null>(null)

    const fetchConfigData = async () => {
        const configData = await wrapNodeRequest<ConfigApiResponseData>('/api/config', 'GET')
        setEnvVariables(configData.envVariables)
        Logger.envVariables = configData.envVariables
    }

    useEffect(() => {
        fetchConfigData()
    }, [])

    const configProviderData: ConfigProviderValue = useMemo(
        () => ({
            envVariables,
        }),
        [{ envVariables }],
    )

    return <ConfigContext.Provider value={configProviderData}>{children}</ConfigContext.Provider>
}
